<template lang="pug">
  .form
    .form__elem
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : fieldsErrors.last_name.value }"
      )
        .form-elem__title Фамилия
        .form-elem__main
          input.input(
          v-model="localLastName"
          @input="resetError('last_name')"
          maxlength="50"
          )
    .form__elem
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : fieldsErrors.first_name.value }"
      )
        .form-elem__title Имя
        .form-elem__main
          input.input(
          v-model="localFirstName"
          @input="resetError('first_name')"
          maxlength="50"
          )
    .form__elem
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : fieldsErrors.fathers_name.value }"
      )
        .form-elem__title Отчество
        .form-elem__main
          input.input(
          v-model="localFathersName"
          @input="resetError('fathers_name')"
          maxlength="50"
          )
    .form__elem.form__elem_short
      .form-elem.form-elem_horizontal
        .form-elem__title Пол
        .form-elem__main
          select.select(
          v-model="localGender"
          @change="changeGenderValue($event)"
          )
            option(
            v-for="item in genderListData"
            :value="item.value"
            ) {{item.text}}
    .form__elem.form__elem_short
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : fieldsErrors.date_of_birth.value }"
      )
        .form-elem__title Дата рождения
        .form-elem__main
          date-picker(
          placeholder="ДД.ММ.ГГГГ"
          v-model="localDateOfBirth"
          format="DD.MM.YYYY"
          lang="ru"
          input-class="input input_full"
          @change="onChangeDate($event)"
          :clearable="false"
          :editable="true"
          :not-after="new Date()"
          :default-value="new Date()"
          )
    .form__elem
      .form-elem.form-elem_horizontal(
      :class="{ 'form-elem_error' : fieldsErrors.place_of_birth.value }"
      )
        .form-elem__title Место рождения
        .form-elem__main
          input.input(
          v-model="localPlaceOfBirth"
          maxlength="50"
          @input="resetError('place_of_birth')"
          )
    .form__elem
      .form-elem.form-elem_horizontal
        .form-elem__title Я сопровождающий делегации
        .form-elem__main
          label.checkbox
            input(
            v-model="localIsAccompanying"
            @change="resetError('parents_phone')"
            type="checkbox"
            )
            .checkbox__text
          .form-elem__description(
            style="margin-top: 20px"
          ) *Для ответственных лиц от муниципальных районов по сопровождению делегации
</template>

<script>
import DatePicker from "vue2-datepicker";

export default {
  name: "form-general-info",
  components: {
    DatePicker,
  },
  props: {
    lastName: {
      type: String,
      default: "",
    },
    firstName: {
      type: String,
      default: "",
    },
    fathersName: {
      type: String,
      default: "",
    },
    gender: {
      type: [Boolean, Object, String],
      default: null,
    },
    dateOfBirth: {
      type: [String, Object],
      default: null,
    },
    placeOfBirth: {
      type: [String, Object],
      default: null,
    },
    isAccompanying: {
      type: Boolean,
      default: false,
    },
    fieldsErrors: {
      type: Object,
      default: () => ({}),
    },
    resetError: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    localLastName: {
      get() {
        return this.lastName;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "last_name"]);
      },
    },
    localFirstName: {
      get() {
        return this.firstName;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "first_name"]);
      },
    },
    localFathersName: {
      get() {
        return this.fathersName;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "fathers_name"]);
      },
    },
    localGender: {
      get() {
        return this.gender;
      },
      set() {},
    },
    localDateOfBirth: {
      get() {
        if (!this.dateOfBirth) {
          return "";
        }
        return this.dateOfBirth;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "date_of_birth"]);
      },
    },
    localPlaceOfBirth: {
      get() {
        return this.placeOfBirth;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "place_of_birth"]);
      },
    },
    localIsAccompanying: {
      get() {
        return this.isAccompanying;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "is_accompanying"]);
      },
    },
  },
  data() {
    return {
      genderListData: [
        {
          text: "Мужской",
          value: true,
        },
        {
          text: "Женский",
          value: false,
        },
      ],
    };
  },
  methods: {
    changeGenderValue(e) {
      this.$emit("onChangeValue", [e.target.value === "true", "gender"]);
    },
    onChangeDate(date) {
      if (date) {
        const d = new Date(date);
        const _date = `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(
          -2
        )}-${("0" + d.getDate()).slice(-2)}`;
        this.$emit("onChangeValue", [_date, "date_of_birth"]);
        this.resetError("date_of_birth");
        return;
      }
      this.$emit("onChangeValue", [null, "date_of_birth"]);
    },
  },
};
</script>
